import { render } from "./ProsedurAi.vue?vue&type=template&id=e1e5b660"
import script from "./ProsedurAi.vue?vue&type=script&lang=js"
export * from "./ProsedurAi.vue?vue&type=script&lang=js"

import "./ProsedurAi.vue?vue&type=style&index=0&id=e1e5b660&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__